import { render, staticRenderFns } from "./ParticipantCard.vue?vue&type=template&id=18545bd5&scoped=true"
import script from "./ParticipantCard.vue?vue&type=script&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipantCard.vue?vue&type=style&index=0&id=18545bd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18545bd5",
  null
  
)

export default component.exports